/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { createStore } from 'redux';

const initialState = {
    user: {
        id: 0,
        firstName: '',
        lastName: '',
        profileImage: null,
        location: [],
        role: [],
        roleid: null
    },
    sidebar: true,
    footer: false,
    toggleSidebar: false,
    refreshInterval: '',
    logoutModal: false,
    refreshPendingList:false,
    taxExemptionPendingList: false,
    taxExemptionAlert: null,
    urlNavigate: '',
    setMessageItemId: null
    // buyerToken:"",
};

/* sets the current state else returns initial state */
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_USER':
            return Object.assign({}, state, { user: { ...state.user, ...action.payload } });
        case 'SET_REFRESH':
            return Object.assign({}, state, { refreshInterval: action.payload });
        case 'SET_SIDEBAR':
            return Object.assign({}, state, { sidebar: action.payload });
        case 'FOOTER':
            return Object.assign({}, state, { footer: action.payload });
        case 'TOGGLE_SIDEBAR':
            return Object.assign({}, state, { toggleSidebar: action.payload });
        case 'TOGGLE_LOGOUT_MODAL':
            return Object.assign({}, state, { logoutModal: action.payload });
        case 'TOGGLE_SESSION_MODAL':
            return Object.assign({}, state, { sessionModal: action.payload });
        case 'SET_REFRESH_PENDING_LIST':
              return Object.assign({}, state, { refreshPendingList: action.payload });
        case 'PENDING_TAX_EXEMPTION_LIST':
            return Object.assign({}, state, { taxExemptionPendingList: action.payload });
        case 'TAX_EXEMPTION_ALERT':
            return Object.assign({}, state, { taxExemptionAlert: action.payload });
        case 'urlNavigate':
            return Object.assign({}, state, { urlNavigate: action.payload });
        case 'SET_MESSAGE_ITEMID':
            return Object.assign({}, state, { setMessageItemId: action.payload });
        default:
            return state;
    }
};

export default createStore(reducer);